module.exports = __webpack_public_path__ + "static/media/Icon_down_outline.6c3ca30a.svg";